import { FC } from 'react'
import { Box } from '@/components/atoms/Grid'
import { ListingData } from 'types/listingData'
import { BridgeProduct } from 'types/bridgeProduct'
import {
  ShowProductModal,
  withProductDetailPopup
} from '@/HOC/withProductDetailPopup'
import { ProductListingFetcher } from '@/components/organisms/productListing/productListingFetcher'
import ProductsContainerRedesign from '@/components/organisms/productsContainerRedesign'

type SearchProductsContainerProps = {
  data: ListingData<BridgeProduct>
  description?: string
  showProductModal?: ShowProductModal
  productListingFetcher: ProductListingFetcher
  list: string
} & Rest

const SearchProductsContainer: FC<SearchProductsContainerProps> = ({
  data,
  showProductModal,
  productListingFetcher,
  list,
  ...rest
}) => (
  <Box
    textAlign="center"
    mb={50}
    flex="1"
    data-testid="productListingContainer"
    {...rest}
  >
    <ProductsContainerRedesign
      fetcher={productListingFetcher}
      data={data}
      action={showProductModal}
      showPager={false}
      list={list}
    />
  </Box>
)

export default withProductDetailPopup(SearchProductsContainer)
